import React from 'react';
import PolicyLayout from '../components/PolicyLayout';

const RefundAndCancellationPolicy: React.FC = () => {
  return (
    <PolicyLayout title="Refund and Cancellation Policy" image="/images/fhome-ingredients-platter.jpg">
      <p>
        This policy explains cancellation and refund terms for purchases made on https://fhome.shop/.
      </p>

      <h3>Cancellation</h3>
      <ul>
        <li>Cancellation requests are accepted within 3 days of placing an order.</li>
        <li>Orders already shipped or out for delivery may not be canceled.</li>
        <li>Perishable items may not be eligible for cancellation.</li>
      </ul>

      <h3>Damaged or Incorrect Items</h3>
      <ul>
        <li>Report damaged or defective products within 3 days of delivery.</li>
        <li>If the delivered item does not match expectation, contact customer support promptly.</li>
      </ul>

      <h3>Refund Timeline</h3>
      <p>
        Approved refunds are processed and credited within 7 business days.
      </p>
    </PolicyLayout>
  );
};

export default RefundAndCancellationPolicy;
